import { props } from './syllabus-block-utils';
import GradeBreakdownChart from 'libs/grade-breakdown-chart';
import Block from './block';

export default {
  props,
  template: '#grading-policy-block-template',
  data() {
    return Object.assign({
      title: '',
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    }
  },
  mounted() {
    GradeBreakdownChart.init('horizontal', this.$el);
  },
  methods:  {
    navigateToGradebook() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your
        grading policies, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };
      const path = Kadenze.Routes.course_grading_policy_entries_path(this.$root.course.id);

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path, opts);
        }, null, opts
      );   
    }
  },
};
